import {Component} from '@angular/core';
import {DebuggingService} from "./services/debugging.service";
import {PrettyJsonPipe} from "../../../../../shared/src/lib/pipe/pretty-json.pipe";
import {MatDialogContent, MatDialogTitle} from "@angular/material/dialog";

@Component({
    selector: 'app-debugging-modal',
    templateUrl: './debugging-modal.component.html',
    styleUrls: ['./debugging-modal.component.scss'],
    imports: [
        PrettyJsonPipe,
        MatDialogTitle,
        MatDialogContent
    ]
})
export class DebuggingModalComponent {

    constructor(
        protected readonly debuggingService: DebuggingService,
    ) {
    }
}
